const statusColors = {
    pending_payment: 'bg-amber-100 text-amber-800',
    confirmed: 'bg-blue-100 text-blue-800',
    processing: 'bg-indigo-100 text-indigo-800',
    shipped: 'bg-purple-100 text-purple-800',
    out_for_delivery: 'bg-orange-100 text-orange-800',
    delivered: 'bg-green-100 text-green-800',
    cancelled: 'bg-red-100 text-red-800',
    return_requested: 'bg-amber-100 text-amber-900',
    returned: 'bg-slate-100 text-slate-800',
    refunded: 'bg-teal-100 text-teal-800',
    payment_failed: 'bg-red-100 text-red-800',
};

export default function OrderStatusBadge({ status }) {
    const formatted = (status || '')
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());

    const colorClass = statusColors[status] || 'bg-muted text-foreground';

    return (
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${colorClass}`}>
            {formatted}
        </span>
    );
}
